import React from 'react';
import Hero from '../components/Hero';
import CategorySection from '../components/CategorySection';
import FeaturedProducts from '../components/FeaturedProducts';
import WelcomeSection from '../components/WelcomeSection';
import SubscribeSection from '../components/SubscribeSection';
import InfoSection from '../components/InfoSection';
import FaqSection from '../components/FaqSection';
import TestimonialsSection from '../components/TestimonialsSection';
const Home = () => {
  return <div className="bg-white w-full" data-id="element-899">
      <Hero data-id="element-900" />
      <CategorySection data-id="element-901" />
      <FeaturedProducts data-id="element-902" />
      <WelcomeSection data-id="element-903" />
      <TestimonialsSection data-id="element-904" />
      <SubscribeSection data-id="element-905" />
      <InfoSection data-id="element-906" />
      <FaqSection data-id="element-907" />
    </div>;
};
export default Home;